import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToggleProperty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2484_195020",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2484_195020)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7 17.5C5.47217 17.5 4.17358 16.9655 3.10425 15.8965C2.03475 14.8275 1.5 13.5294 1.5 12.0023C1.5 10.4751 2.03475 9.17625 3.10425 8.10575C4.17358 7.03525 5.47217 6.5 7 6.5H17C18.5278 6.5 19.8264 7.0345 20.8958 8.1035C21.9653 9.1725 22.5 10.4706 22.5 11.9978C22.5 13.5249 21.9653 14.8237 20.8958 15.8942C19.8264 16.9648 18.5278 17.5 17 17.5H7ZM7 16H17C18.1 16 19.0417 15.6083 19.825 14.825C20.6083 14.0417 21 13.1 21 12C21 10.9 20.6083 9.95833 19.825 9.175C19.0417 8.39167 18.1 8 17 8H7C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM16.9988 14.75C17.7624 14.75 18.4118 14.4827 18.947 13.9482C19.4823 13.4137 19.75 12.7648 19.75 12.0012C19.75 11.2376 19.4827 10.5882 18.9482 10.053C18.4137 9.51767 17.7647 9.25 17.0013 9.25C16.2376 9.25 15.5882 9.51725 15.053 10.0518C14.5177 10.5863 14.25 11.2352 14.25 11.9988C14.25 12.7624 14.5173 13.4118 15.0518 13.947C15.5863 14.4823 16.2353 14.75 16.9988 14.75Z",
			fill: "currentColor"
		})
	})]
});
export default SvgToggleProperty;
